<script>
  import { t } from '../../i18n/index.js';

  let { onclick, disabled = false } = $props();
</script>

<button
  {onclick}
  {disabled}
  class="capture-btn"
  class:disabled
>
  <span class="sr-only">{t('camera.capture')}</span>
</button>

<style>
  .capture-btn {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: white;
    border: 4px solid #d1d5db;
    cursor: pointer;
    transition: transform 0.15s, opacity 0.15s;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .capture-btn:hover {
    background: #f3f4f6;
  }

  .capture-btn:active {
    transform: scale(0.95);
  }

  .capture-btn.disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: scale(0.9);
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
</style>
